let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6r90a")).then(() => parcelRequire('4ZPCd'));